<template>
  <div>
    <input :id="id"
      v-bind="$attrs"
      type="radio"
      :class="[
        {'d-none': dNone}
      ]
    ">
    <label :for="id" class="w-100 mb-3">
      <slot name="label" />
    </label>
  </div>
</template>

<script>
export default {
  inheritAttrs:false,
  props:{
    dNone:{
      type: Boolean,
      default: true
    },
    active: {
      type: Boolean,
      default: false
    },
    id: String
  }
}
</script>

<style>

</style>